import {Button, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import {Add} from "@mui/icons-material";
import {useRef} from "react";
import useAlert from "../../../../../../use/useAlert";

const ERROR_NAME_REQUIRED = "Nom requis.";
const ERROR_PRICING_REQUIRED = "Prix requis.";
const ERROR_QUANTITY_REQUIRED = "Quantité requise.";

export default function ({onSubmit, defaultName = null}) {
    const alert = useAlert();
    const nameInput = useRef();
    const pricingInput = useRef();
    const quantityInput = useRef();

    const handleSubmit = () => {
        if (!nameInput.current.value) {
            alert.warning(ERROR_NAME_REQUIRED);
            return;
        }

        if (!pricingInput.current.value) {
            alert.warning(ERROR_PRICING_REQUIRED);
            return;
        }

        if (!quantityInput.current.value) {
            alert.warning(ERROR_QUANTITY_REQUIRED);
            return;
        }

        onSubmit({
            name: nameInput.current.value,
            pricing: Math.round(parseFloat(pricingInput.current.value) * 100),
            quantity: parseInt(quantityInput.current.value, 10),
            standardized_item_id: null
        });

        nameInput.current.value = "";
        pricingInput.current.value = "";
        quantityInput.current.value = "1";
    }

    return (
        <>
            <TextField
                inputRef={nameInput}
                fullWidth
                variant={"standard"}
                label={"Désignation"}
                defaultValue={defaultName}
                required
                data-test="insurance-input-name"
            />
            <Box mt={2}>
                <TextField
                    inputRef={pricingInput}
                    fullWidth
                    variant={"standard"}
                    label={"Prix HT (€)"}
                    type={"number"}
                    inputProps={{step: "0.01", min: "0"}}
                    required
                    data-test="insurance-input-pricing"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={quantityInput}
                    fullWidth
                    variant={"standard"}
                    label={"Quantité"}
                    type={"number"}
                    defaultValue={1}
                    inputProps={{min: "1", step: "1"}}
                    required
                    data-test="insurance-input-quantity"
                />
            </Box>
            <Box mt={3} display="flex" justifyContent="center">
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<Add/>}
                    fullWidth
                    onClick={handleSubmit}
                    data-test="insurance-button-create-item"
                >
                    Ajouter
                </Button>
            </Box>
        </>
    );
}
